import type { MittwaldAPIV2 } from "@mittwald/api-client-NEXT";

type ValidationErrorData =
  MittwaldAPIV2.Components.Schemas.CommonsValidationErrorSchema;

export const checkForValidationErrors = (response: Record<never, never>) => {
  if (
    "status" in response &&
    response.status === 400 &&
    "data" in response &&
    typeof response.data === "object" &&
    response.data !== null &&
    "validationErrors" in response.data
  ) {
    return (response.data.validationErrors as ValidationErrorData[]).map(
      (d) => new ValidationError(d),
    );
  }
};

export class ValidationError {
  public readonly path: string;
  public readonly message?: string;
  public readonly type: string;
  public readonly context?: { [k: string]: string };

  public constructor(data: ValidationErrorData) {
    this.path = data.path;
    this.message = data.message;
    this.type = data.type;
    this.context = data.context;
  }
}
